import { useBoolean, Box } from '@chakra-ui/react';
import React from 'react';
import FileViewer from '../../../components/pdf_viewer/FileViewer';
import { SheetEyeIcon } from '../../../constants/IconData';
import { useAuditReportAttachment } from '../../../components/pdf_viewer/AuditReportViewer';

const AuditSheetFileViewer = ({ auditData, icon, chart_id=null }) => {
  const [isFileOpen, ifoState] = useBoolean(false);
  const { attachment } = useAuditReportAttachment({ chartId: chart_id });

  return (
    <React.Fragment>
      {icon ? 
      <Box onClick={ifoState.on}
        style={{
          width: 40,
          height: 40,
          cursor: 'pointer',
          display: 'inline-block',
        }}> {icon}</Box> : <SheetEyeIcon
        onClick={ifoState.on}
        style={{
          width: 40,
          height: 40,
          cursor: 'pointer',
          display: 'inline-block',
        }}
      />}
      <FileViewer
        isOpen={isFileOpen}
        currentFile={auditData?.file_obj}
        attachments={[
          ...(auditData?.attachments || []),
          ...(attachment ? [attachment] : [])
        ]}
        onClose={ifoState.off}
      />
    </React.Fragment>
  );
};

export default AuditSheetFileViewer;
